import { createEffect, createEvent, createStore, sample } from "effector";
import { getMe, updateUserSettings, UserProfile, UserSettings } from "./api";
import { notifications } from "@mantine/notifications";

const fetchProfileFx = createEffect(() => {
  return getMe();
});

const updateUserSettingsFx = createEffect(updateUserSettings);

const $profile = createStore<null | UserProfile>(null);
const $settings = fetchProfileFx.doneData.map((data) => data.settings || null);
const updateUserSettingsEvent = createEvent<UserSettings>();

const $currentSimilarity = createStore(80).on(
  $settings,
  (_, payload) => payload?.similarity || 80
);

sample({
  clock: fetchProfileFx.doneData,
  target: $profile,
});

sample({
  clock: updateUserSettingsEvent,
  target: updateUserSettingsFx,
});

sample({
  clock: updateUserSettingsFx.doneData,
  target: fetchProfileFx,
});

updateUserSettingsFx.done.watch(() => {
  notifications.show({
    message: "User settings updated successfully",
    color: "green",
  });
});

updateUserSettingsFx.fail.watch(() => {
  notifications.show({
    message: "User settings update failed",
    color: "red",
  });
});

export const viewerEntity = {
  fetchProfileFx,
  $profile,
  $settings,
  $currentSimilarity,
  updateUserSettingsEvent,
  updateUserSettingsFx,
};
